/*
 * Double Dip Chips: cart upsell ("You might also like").
 * Used by snippets/cart-upsell.liquid on the cart page and inside the cart drawer.
 * Picks 3 random flavors per view (client-side) from the JSON rendered by Liquid,
 * excluding products already in the cart, and adds them with /cart/add.js.
 * Blocks with data-kind="deals" ("This week's deals") show every deal flavor in order
 * (no shuffle), marked with their percent off; the upsell excludes those flavors.
 */
(function () {
  if (window.DDCCartUpsell) return;

  var SHOW_COUNT = 3;
  var ROOT_SELECTOR = '[data-cart-upsell]';

  function readData(root) {
    if (root.ddcUpsellData) return root.ddcUpsellData;
    var script = root.querySelector('[data-cart-upsell-data]');
    var data = null;
    try {
      data = JSON.parse(script ? script.textContent : 'null');
    } catch (e) {
      data = null;
    }
    if (!data || !Array.isArray(data.products)) data = { cart: [], products: [] };
    if (!Array.isArray(data.exclude)) data.exclude = [];
    root.ddcUpsellData = data;
    return data;
  }

  function shuffle(list) {
    for (var i = list.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function buildCard(root, product) {
    var labels = root.dataset;
    var card = el('li', 'cart-upsell__card');
    card.dataset.productId = String(product.id);

    var media = el('a', 'cart-upsell__media');
    media.href = product.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (product.percent) {
      media.appendChild(el('span', 'cart-deals__badge', product.percent + '% off'));
    }
    if (product.image) {
      var img = document.createElement('img');
      img.src = product.image;
      img.alt = '';
      img.loading = 'lazy';
      img.width = 360;
      img.height = Math.round(360 / (Number(product.image_ratio) || 0.8));
      media.appendChild(img);
    }
    card.appendChild(media);

    var title = el('a', 'cart-upsell__title', product.title);
    title.href = product.url;
    card.appendChild(title);

    var price = el('div', 'cart-upsell__price');
    if (product.compare_at_price) {
      price.appendChild(el('span', 'visually-hidden', labels.labelRegular || 'Regular price'));
      price.appendChild(el('s', 'double-dip-spoon__compare cart-upsell__compare', product.compare_at_price));
      price.appendChild(el('span', 'visually-hidden', labels.labelSale || 'Sale price'));
      price.appendChild(el('span', 'double-dip-spoon__sale-price cart-upsell__sale', product.price));
    } else {
      price.appendChild(el('span', 'cart-upsell__regular', product.price));
    }
    card.appendChild(price);
    if (product.percent) {
      card.appendChild(el('div', 'cart-deals__note', product.percent + '% off at checkout'));
      if (cartIdsFrom(root).indexOf(Number(product.id)) !== -1) {
        card.appendChild(el('div', 'cart-deals__incart', 'In your cart'));
      }
    }

    var actions = el('div', 'cart-upsell__actions');
    var button = el('button', 'cart-upsell__add button button--primary focus-inset');
    button.type = 'button';
    button.dataset.cartUpsellAdd = '';
    button.dataset.variantId = String(product.variant_id);
    button.dataset.productId = String(product.id);
    button.dataset.productTitle = product.title;
    button.setAttribute('aria-label', (labels.labelAdd || 'Add to cart') + ': ' + product.title);
    var content = el('span', 'button__content');
    var label = el('span', 'button__label', labels.labelAdd || 'Add to cart');
    label.dataset.label = labels.labelAdd || 'Add to cart';
    content.appendChild(label);
    button.appendChild(content);
    button.appendChild(el('span', 'animated-button-circle'));
    actions.appendChild(button);
    card.appendChild(actions);

    return card;
  }

  function cartIdsFrom(root) {
    if (Array.isArray(root.ddcCartIds)) return root.ddcCartIds;
    return (readData(root).cart || []).map(Number);
  }

  // Render (or re-render) one upsell block. keepIfValid avoids reshuffling when the
  // currently shown picks are still valid (e.g. a quantity change on the cart page).
  function render(root, keepIfValid) {
    var data = readData(root);
    var inCart = cartIdsFrom(root);
    var grid = root.querySelector('[data-cart-upsell-grid]');
    root.dataset.upsellReady = 'true';
    if (!grid) return;

    if (!inCart.length) {
      root.hidden = true;
      return;
    }

    if (root.dataset.kind === 'deals') {
      var ends = data.ends_at ? Date.parse(data.ends_at) : NaN;
      var deals = data.products.filter(function (p) {
        return p && p.variant_id && p.percent;
      });
      if (!deals.length || (!isNaN(ends) && Date.now() > ends)) {
        root.hidden = true;
        grid.textContent = '';
        return;
      }
      grid.textContent = '';
      deals.forEach(function (product) {
        grid.appendChild(buildCard(root, product));
      });
      root.hidden = false;
      return;
    }

    if (keepIfValid && root.ddcPicks && root.ddcPicks.length) {
      var stillValid = root.ddcPicks.every(function (p) {
        return inCart.indexOf(Number(p.id)) === -1;
      });
      if (stillValid) {
        root.hidden = false;
        return;
      }
    }

    var candidates = data.products.filter(function (p) {
      return (
        p &&
        p.variant_id &&
        inCart.indexOf(Number(p.id)) === -1 &&
        data.exclude.indexOf(Number(p.id)) === -1
      );
    });

    if (!candidates.length) {
      root.hidden = true;
      grid.textContent = '';
      root.ddcPicks = [];
      return;
    }

    var picks = shuffle(candidates.slice()).slice(0, SHOW_COUNT);
    root.ddcPicks = picks;
    grid.textContent = '';
    picks.forEach(function (product) {
      grid.appendChild(buildCard(root, product));
    });
    root.hidden = false;

    if (typeof window.initButtonsAnimation === 'function') {
      try {
        window.initButtonsAnimation(grid);
      } catch (e) {}
    }
  }

  function scan() {
    document.querySelectorAll(ROOT_SELECTOR + ':not([data-upsell-ready])').forEach(function (root) {
      render(root, false);
    });
  }

  var scanQueued = false;
  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(function () {
      scanQueued = false;
      scan();
    });
  }

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function setStatus(root, message) {
    if (!root) return;
    var status = root.querySelector('[data-cart-upsell-status]');
    if (status) {
      status.textContent = '';
      setTimeout(function () {
        status.textContent = message;
      }, 100);
    }
  }

  function refreshCartPage(sections, addedProductId, title, root) {
    var mainItems = document.getElementById('main-cart-items');
    var sectionId = mainItems && mainItems.dataset.id;
    var itemsHTML = sectionId && sections[sectionId] && sectionInnerHTML(sections[sectionId], '.js-contents');
    var itemsTarget = mainItems && mainItems.querySelector('.js-contents');
    if (!itemsHTML || !itemsTarget) throw new Error('cart page re-render unavailable');

    itemsTarget.innerHTML = itemsHTML;

    var targets = [
      ['main-cart-footer', '.js-contents-totals', sectionId],
      ['main-cart-shipping', '.js-contents-shipping', sectionId],
      ['cart-icon-bubble', '.shopify-section', 'cart-icon-bubble'],
      ['cart-live-region-text', '.shopify-section', 'cart-live-region-text']
    ];
    targets.forEach(function (t) {
      var wrapper = document.getElementById(t[0]);
      var html = sections[t[2]];
      if (!wrapper || !html) return;
      var target = t[1] === '.shopify-section' ? wrapper : wrapper.querySelector(t[1]) || wrapper;
      var inner = sectionInnerHTML(html, t[1] === '.shopify-section' ? '.shopify-section' : t[1]);
      if (inner != null) target.innerHTML = inner;
    });

    ['.main-cart__wrapper', 'cart-items', '#main-cart-footer'].forEach(function (sel) {
      var node = document.querySelector(sel);
      if (node) node.classList.remove('is-empty');
    });

    var cartItems = document.querySelector('cart-items');
    if (cartItems && typeof cartItems.cartShipping === 'function' && document.querySelector('.cart-shipping__progress')) {
      try {
        cartItems.cartShipping();
      } catch (e) {}
    }
    var slider = document.querySelector('cart-popular-products-slider');
    if (slider && typeof slider.init === 'function') {
      try {
        slider.init();
      } catch (e) {}
    }

    // Exclude the product just added and pick a fresh set.
    var ids = cartIdsFrom(root).slice();
    if (addedProductId && ids.indexOf(addedProductId) === -1) ids.push(addedProductId);
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (block) {
      block.ddcCartIds = ids;
      render(block, block !== root);
    });
    setStatus(root, title + ' added to cart');
  }

  function onAddClick(event) {
    var button = event.target.closest('[data-cart-upsell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var root = button.closest(ROOT_SELECTOR);
    var context = root ? root.dataset.context : 'page';
    var labels = root ? root.dataset : {};
    var label = button.querySelector('.button__label');
    var originalText = labels.labelAdd || 'Add to cart';
    var variantId = Number(button.dataset.variantId);
    var title = button.dataset.productTitle || '';
    var errorBox = root && root.querySelector('[data-cart-upsell-error]');
    if (!variantId) return;

    if (errorBox) errorBox.textContent = '';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) {
      label.textContent = labels.labelAdding || 'Adding…';
      label.dataset.label = label.textContent;
    }

    var drawer = document.querySelector('cart-drawer');
    var mainItems = document.getElementById('main-cart-items');
    var sections = [];
    if (context === 'drawer' && drawer && typeof drawer.renderContents === 'function') {
      sections = ['cart-drawer', 'cart-icon-bubble'];
    } else if (context === 'page' && mainItems && mainItems.dataset.id) {
      sections = [mainItems.dataset.id, 'cart-icon-bubble', 'cart-live-region-text'];
    }

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (sections.length) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) {
            var err = new Error(json.description || json.message || 'add failed');
            err.userFacing = json.description || json.message;
            throw err;
          }
          return json;
        });
      })
      .then(function (json) {
        var added = json.items && json.items[0];
        var addedProductId = added ? Number(added.product_id) : Number(button.dataset.productId);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-upsell', items: json.items } }));

        if (!json.sections || !sections.length) {
          window.location.reload();
          return;
        }
        try {
          if (context === 'drawer') {
            drawer.renderContents(json);
            setTimeout(function () {
              var fresh = document.querySelector('cart-drawer ' + ROOT_SELECTOR);
              setStatus(fresh, title + ' added to cart');
            }, 150);
          } else {
            refreshCartPage(json.sections, addedProductId, title, root);
          }
        } catch (e) {
          window.location.reload();
        }
      })
      .catch(function (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        if (label) {
          label.textContent = originalText;
          label.dataset.label = originalText;
        }
        if (errorBox) {
          errorBox.textContent = error.userFacing || labels.labelError || 'Unable to add this item. Please try again.';
        }
      });
  }

  // Theme fires cart:change (with the updated cart) after quantity edits / removals.
  function onCartChange(event) {
    var cart = event.detail && event.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    var ids = cart.items.map(function (item) {
      return Number(item.product_id);
    });
    document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      root.ddcCartIds = ids;
      render(root, true);
    });
  }

  function init() {
    scan();
    document.addEventListener('click', onAddClick);
    document.addEventListener('cart:change', onCartChange);
    if ('MutationObserver' in window) {
      new MutationObserver(queueScan).observe(document.body, { childList: true, subtree: true });
    }
  }

  window.DDCCartUpsell = { render: render, scan: scan };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
